/*
 * Rowdy: journal stories. Older posts were written in different editors over the years, so this tidies
 * them as the page loads, without touching the admin text:
 * - removes empty lines, shows "Rowdy" rather than "ROWDY", keeps headings out of capitals
 * - an opening subtitle (a heading before any text) becomes the standfirst under the title
 * - lone pictures sit in a figure, quotes become pull quotes, links to other sites open in a new tab
 * - a thin reading-progress line, and the "copy link" button
 */
(function () {
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  function sentenceCase(str) {
    var t = str.trim();
    if (t.length < 3 || t !== t.toUpperCase() || !/[A-Z]/.test(t)) return null;
    t = t.toLowerCase();
    return t.charAt(0).toUpperCase() + t.slice(1);
  }

  function tidy(story, body) {
    // Empty paragraphs and stray breaks
    body.querySelectorAll('p, div').forEach(function (el) {
      if (!el.textContent.replace(/ /g, ' ').trim() && !el.querySelector('img, iframe, video, picture')) el.remove();
    });
    Array.prototype.slice.call(body.children).forEach(function (el) { if (el.tagName === 'BR') el.remove(); });
    // Centred or justified paragraphs left over from old editors read badly in a column
    body.querySelectorAll('p, h2, h3, h4, li').forEach(function (el) {
      if (el.style && el.style.textAlign) el.style.textAlign = '';
      el.removeAttribute('data-mce-style');
      if (el.getAttribute('style') === '') el.removeAttribute('style');
    });
    // Brand name
    var walker = document.createTreeWalker(body, NodeFilter.SHOW_TEXT), node;
    while ((node = walker.nextNode())) {
      if (/\bROWDY\b/.test(node.nodeValue)) node.nodeValue = node.nodeValue.replace(/\bROWDY\b/g, 'Rowdy');
    }
    // Headings: no shouting capitals, no bold inside
    body.querySelectorAll('h1, h2, h3, h4').forEach(function (h) {
      h.querySelectorAll('strong, b').forEach(function (b) { b.replaceWith(document.createTextNode(b.textContent)); });
      var sc = sentenceCase(h.textContent); if (sc) h.textContent = sc;
    });
    // An h1 inside the story competes with the page title
    body.querySelectorAll('h1').forEach(function (h) { var n = document.createElement('h2'); n.innerHTML = h.innerHTML; h.replaceWith(n); });
    // Opening subtitle -> standfirst
    var first = body.firstElementChild;
    var stand = story.querySelector('[data-rjn-standfirst]');
    var title = story.querySelector('.rjn-story__title');
    if (first && /^H[2-4]$/.test(first.tagName)) {
      var txt = first.textContent.trim();
      if (title && txt.toLowerCase() === title.textContent.trim().toLowerCase()) first.remove();
      else if (stand && stand.hidden && txt.length < 160) { stand.textContent = txt; stand.hidden = false; first.remove(); }
    }
    // Lone pictures: give them a figure so they can run full width
    body.querySelectorAll('p').forEach(function (p) {
      var imgs = p.querySelectorAll('img');
      if (imgs.length === 1 && !p.textContent.trim()) {
        var fig = document.createElement('figure'); fig.className = 'rjn-fig';
        var img = imgs[0]; img.loading = 'lazy';
        fig.appendChild(img.closest('a') && p.contains(img.closest('a')) ? img.closest('a') : img);
        if (img.alt && img.alt.length > 12 && !/\.(jpe?g|png|webp)$/i.test(img.alt)) {
          var cap = document.createElement('figcaption'); cap.textContent = img.alt; fig.appendChild(cap);
        }
        p.replaceWith(fig);
      }
    });
    // First real paragraph gets the drop cap
    var firstP = Array.prototype.find.call(body.children, function (el) { return el.tagName === 'P' && el.textContent.trim().length > 80; });
    if (firstP && firstP === body.querySelector('p')) firstP.classList.add('rjn-lede');
    // Links to other sites open in a new tab
    body.querySelectorAll('a[href^="http"]').forEach(function (a) {
      try {
        var u = new URL(a.href);
        if (u.hostname !== location.hostname && !/rowdybags\.co\.uk$/.test(u.hostname)) { a.target = '_blank'; a.rel = 'noopener'; }
      } catch (e) {}
    });
    // Tables scroll on small screens
    body.querySelectorAll('table').forEach(function (t) {
      var w = document.createElement('div'); w.className = 'rjn-table'; t.parentNode.insertBefore(w, t); w.appendChild(t);
    });
  }

  function progress(body) {
    var bar = document.createElement('div');
    bar.className = 'rjn-progress';
    bar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(bar);
    function update() {
      var r = body.getBoundingClientRect();
      var total = r.height - window.innerHeight * 0.5;
      var done = Math.min(1, Math.max(0, (-r.top + window.innerHeight * 0.25) / Math.max(total, 1)));
      bar.style.transform = 'scaleX(' + done + ')';
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function copy(story) {
    var btn = story.querySelector('[data-rjn-copy]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var url = btn.getAttribute('data-rjn-copy');
      var done = function () {
        var msg = btn.querySelector('[data-rjn-copied]');
        if (!msg) return;
        msg.hidden = false; btn.classList.add('is-copied');
        setTimeout(function () { msg.hidden = true; btn.classList.remove('is-copied'); }, 2200);
      };
      if (navigator.clipboard) navigator.clipboard.writeText(url).then(done, function () {});
    });
  }

  ready(function () {
    var story = document.querySelector('[data-rjn-story]');
    if (!story) return;
    var body = story.querySelector('[data-rjn-body]');
    if (!body) return;
    tidy(story, body);
    progress(body);
    copy(story);
  });
})();
